import { useRouter } from '@/hooks';
import { Box } from '@mui/material';
import { useFetchCookies } from '@/hooks/useFetchCookies';
import { PageLoader } from '@/components/shared/PageLoader';
import { AssetLabelling } from '@/components/AssetLabelling';
import { StructureCheck } from '@/components/shared/StructureCheck';
import { DefaultLayout } from '@/layouts';

const ViewerPage = () => {
  const router = useRouter();
  const { inspection } = router.query;
  const cookiesFetched = useFetchCookies();
  if (!inspection || Array.isArray(inspection)) {
    return <div>Please specify inspection id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <StructureCheck structureId={inspection}>
      <DefaultLayout>
        <AssetLabelling structureId={inspection} />
      </DefaultLayout>
    </StructureCheck>
  );
};

export default ViewerPage;
